import React from "react";

import { FORM_SUBMISSION_TYPES } from "globals/constants";

import Agreements from "./Agreements";
import ExternalRecords from "./ExternalRecords";

export const RelatedRecords = ({ formType }) => (
	<>
		{formType !== FORM_SUBMISSION_TYPES.PROPOSAL && <Agreements formType={formType}/>}
		{formType !== FORM_SUBMISSION_TYPES.PROJECT && <ExternalRecords formType={formType} />}
	</>
);

export default RelatedRecords;